import { type FunctionComponent } from 'react';
import { Status } from '../../status';
import { ErrorCommon } from '../error-common/error-common.component';

export const FiveHundred: FunctionComponent = () => (
	<Status code={500}>
		<ErrorCommon />
	</Status>
);
